import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const LocalAuthors = () => <EventCategoryPage config={EVENT_CATEGORIES['local-authors']} data-id="element-9874" data-mp="2ih0akfsfcwat" />;
export default LocalAuthors;